import { render, staticRenderFns } from "./BookingPreview.vue?vue&type=template&id=2e6c17a8"
import script from "./BookingPreview.vue?vue&type=script&lang=js"
export * from "./BookingPreview.vue?vue&type=script&lang=js"
import style0 from "./BookingPreview.vue?vue&type=style&index=0&id=2e6c17a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports